var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getNodePlanData from './getNodePlanData';
import AppState from '../AppState';
/**
 * Sends selected plan data to the sales funnel.
 *
 * @param {string} selectedPlanId - The identifier of the selected plan.
 * @param {AvailableSelections[]} allPlans - An array of all available plans.
 * @returns {Promise<void>}
 */
const sendToSalesFunnel = (selectedPlanId, allPlans) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const salesId = AppState.get('salesId');
    const token = AppState.get('token');
    const sfpModel = AppState.get('serviceFunnelPackage');
    const { Window, settings } = drupalJsObjects;
    const { vocusApiRoot, vocusApiSaveCart, purchaseFunnelRoot } = settings;
    const planObject = allPlans.find(plan => plan.PlanIdentifier === selectedPlanId);
    let nodeData;
    nodeData = yield AppState.get('selectedPlanData');
    if (!nodeData || !nodeData.data || !nodeData.data[0] || !nodeData.data[0].attributes) {
        const planType = AppState.get('planType');
        nodeData = yield getNodePlanData(selectedPlanId, planType);
    }
    const { title, field_plan_speed_download, field_plan_speed_upload, } = nodeData.data[0].attributes;
    if (['SBCHRG7', 'SBCHRG8', 'SBCHRG9', 'SBCHRG11'].includes(planObject.PlanIdentifier)) {
        if (planObject.ProductDescriptions) {
            const productDescription = planObject.ProductDescriptions.find(plan => plan.Label === 'Discount Amount');
            if (productDescription && productDescription.Text !== null) {
                sfpModel.internetSelection.discount.discountPrice = planObject.price - Number(productDescription.Text);
                sfpModel.internetSelection.discount.discountType = productDescription.Label;
                sfpModel.internetSelection.discount.discountAmount = productDescription.Text;
            }
        }
    }
    sfpModel.internetSelection.planIdentifier = planObject.PlanIdentifier;
    sfpModel.internetSelection.planName = title;
    sfpModel.internetSelection.price = planObject.price.toString();
    sfpModel.internetSelection.showFibreUpgrade = planObject.showFibreUpgrade;
    sfpModel.internetSelection.showSpeedUpgrade = planObject.showSpeedUpgrade;
    sfpModel.internetSelection.download = field_plan_speed_download.toString();
    sfpModel.internetSelection.upload = field_plan_speed_upload.toString();
    if (!['SBCHRG9', 'SBCHRG11'].includes(planObject.PlanIdentifier)) {
        sfpModel.internetSelection.showFibreUpgrade = false;
        sfpModel.internetSelection.showSpeedUpgrade = false;
    }
    const dataBuild = {
        salesId: parseInt(salesId),
        token: token,
        cartJson: JSON.stringify(sfpModel),
        action: 'CART',
    };
    fetch(vocusApiRoot + vocusApiSaveCart, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(dataBuild),
    })
        .then(response => {
        if (!response.ok) {
            throw new Error('Could not save cart.');
        }
        else {
            Window.location.href = `${purchaseFunnelRoot}internet/addons?salesId=${salesId}&token=${token}&route=established`;
        }
    })
        .catch(error => console.log('Error: ', error));
});
export default sendToSalesFunnel;
